import { Injectable } from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Subject } from 'rxjs';
import { map, scan} from 'rxjs/operators';
import { SpinnerComponent } from '../app/generico/spinner/spinner.component';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {

  private spinnerTopRef = this.cdkSpinnerCreate();
  spin$ : Subject<boolean> ;

  constructor(
    private overlay: Overlay,
  ) {

    this.spin$  = new Subject();

    this.spin$
      .asObservable()
      .pipe(
        map(val => val ? 1 : -1 ),
        scan((acc, one) => (acc + one) >= 0 ? acc + one : 0, 0)
      )
      .subscribe(
        (res) => {
          if (res > 0 ) {
            this.stopSpinner()
            this.spinnerTopRef = this.cdkSpinnerCreate();
            this.showSpinner();           

          } else if (res === 0 && this.spinnerTopRef.hasAttached()) {
            this.stopSpinner();
          }
        }, (err) => {
          console.log(err);
        }
      );
  }

  private cdkSpinnerCreate() {
    /* return this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'dark-backdrop',
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically()
    }); */

    const positionStrategy = this.overlay.position()
      .global()
      .centerHorizontally()
      .centerVertically();

    let config = {'positionStrategy' : positionStrategy,
                  hasBackdrop: true 
                  };
    // Returns an OverlayRef which is a PortalHost
    let overlayRef = this.overlay.create(config);

    return overlayRef;

  }

  private showSpinner() {
    this.spinnerTopRef.attach(new ComponentPortal(SpinnerComponent));
  }

  private stopSpinner() {
    this.spinnerTopRef.detach();
  }
}
